<div class="r-panel">
    <div class="panel-title">
        <span>{{stepNumber}}</span>
        <p>{{'select.stake' | translate}}</p>
    </div>
    <div class="l-panel-ctn">
        <!-- Vue des mises de base -->
        @if (!afficherToutesLesMises) {
        <div class="group-panel-item">
            @for (mise of misesDeBase; track $index) {
            <button
                matRipple
                [matRippleCentered]="rippleOptions.centered"
                [matRippleDisabled]="rippleOptions.disabled"
                [matRippleUnbounded]="rippleOptions.unbounded"
                [matRippleRadius]="rippleOptions.radius"
                [matRippleColor]="rippleOptions.color"
            class="r-panel-item" [class.selected]="mise.selectionne" (click)="selectionnerMise(mise)">
                <!-- {{ mise.montant }} {{currency}} -->
                  {{mise.montant | currencyFormatter}}
            </button>
            }
        </div>
        }
        <!-- Vue des mises supplémentaires -->
        @if (afficherToutesLesMises) {
        <div class="group-panel-item">
            @for (mise of misesSupplemetaires; track $index) {
            <button
                matRipple
                [matRippleCentered]="rippleOptions.centered"
                [matRippleDisabled]="rippleOptions.disabled"
                [matRippleUnbounded]="rippleOptions.unbounded"
                [matRippleRadius]="rippleOptions.radius"
                [matRippleColor]="rippleOptions.color"
                class="r-panel-item small"
                [class.selected]="mise.selectionne" (click)="selectionnerMise(mise)">
                <!-- {{ mise.montant }} {{currency}} -->
                {{mise.montant | currencyFormatter}}

            </button>
            }
        </div>
        }
        <button class="r-panel-item small" (click)="toggleAffichage()">
            {{ (afficherToutesLesMises ? 'stake.default' : 'stake.all') | translate }}
          </button>
    </div>
</div>
